// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3sSQm","title":"ClientInsurance_title__8YrjH","itemText":"ClientInsurance_itemText__2_thB"};